module.exports = __webpack_public_path__ + "img/story001.41f46105.png";